import { useQuests } from '@src/hooks/useQuests';
import { QuestBento } from './QuestBento';
import { Skeleton, Text, VStack } from 'ui_2';

export const QuestBentos = () => {
  const { data, isLoading, error } = useQuests();

  if (isLoading) {
    return (
      <div className='grid w-full grid-cols-1 justify-items-center gap-4 md:grid-cols-2 md:gap-8'>
        {[...Array(3).keys()].map((key) => (
          <Skeleton
            className='h-[246px] w-full max-w-[450px]'
            delay={key}
            key={key}
          />
        ))}
      </div>
    );
  } else if (error) {
    return (
      <VStack className='items-center'>
        <Text>Error Loading Quests!</Text>
        <Text font='sm'>{error.message}</Text>
      </VStack>
    );
  }

  return (
    <div className='grid w-full grid-cols-1 justify-items-center gap-4 md:grid-cols-2 md:gap-8'>
      {data?.map((quest) => (
        <QuestBento key={quest._id} quest={quest} />
      ))}
    </div>
  );
};
